import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import { ACTION_BACK_PATH, GENETIC_DETAILS_PATH, GENETIC_REPORTS_PATH } from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const GeneticReportsPage = lazy(() => import('./pages/GeneticReportsPage'));
const GeneticDetailsPage = lazy(() => import('./pages/GeneticDetailsPage'));

export const GENETIC_REPORTS_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <GeneticReportsPage />,
    displayTitle: () => 'Genetic Reports',
    pageType: PageType.PRIVATE,
    path: GENETIC_REPORTS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.geneticReports,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <GeneticDetailsPage />,
    displayTitle: () => 'Genetic Report Details',
    pageType: PageType.PRIVATE,
    path: GENETIC_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.geneticReports,
  },
];
